const sleep = m => new Promise(r => setTimeout(r, m))

const start = async function(videoId) {
    await sleep(300);
    var video = document.getElementById(videoId)
    video.muted = true;
    video.autoplay = true;
    video.loop = true;
    video.play()
}

const stop = async function(videoId) {
    return true
}


module.exports = {
    start,
    stop
}
